import { IonText, useIonModal } from '@ionic/react'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import { useContext, useState } from 'react'
import styled from 'styled-components'
import { TradeHistoryListDone } from '../../../common'
import { CustomSpacer, PagingContent } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { TradeResultConfirmModal } from './modals/TradeResultConfirmModal'

type Props = {
  productId: number
}

export const TradeHistoryDone: React.FC<Props> = observer(({ productId }) => {
  const { marketStore } = useContext(StoresContext)
  const [tradeResult, setTradeResult] = useState<TradeHistoryListDone>()
  const pagingStore = marketStore.tradeHistoryDonePagingStore

  const [txDetailPresent, txDetailDismiss] = useIonModal(TradeResultConfirmModal, {
    tradeResult: tradeResult,
    onDismiss: () => {
      txDetailDismiss()
    },
  })

  const onTxDetailModal = (tradeResult: TradeHistoryListDone) => {
    setTradeResult(tradeResult)
    txDetailPresent()
  }

  // 총 거래 금액
  const totalCost = (count: number, cost: number) => {
    const totalCost = Math.abs(count) * cost
    return Math.floor(totalCost).toLocaleString()
  }

  return (
    <PagingContent pagingStore={pagingStore} loadParam={{ param: { productId: productId } }}>
      {pagingStore.list.map((d, i) => (
        <ProductInfoContainer key={i}>
          <DateContainer>
            <IonText className="date">{`${moment(new Date(d.createdDate)).format('YY.MM.DD')}`}</IonText>
            <IonText className="time">{`${moment(new Date(d.createdDate)).format('HH:MM')}`}</IonText>
          </DateContainer>
          <SectionContainer>
            <HistoryInfoContainer onClick={() => onTxDetailModal(pagingStore.list[i])}>
              <IonText color={d.tradeOrder?.type === 'SELL' ? 'danger' : 'primary'} className="section-title">
                {d.tradeOrder?.type === 'SELL' ? '매도' : '매수'}
              </IonText>
              <IonText className="order-sequence">(주문 번호 : {d.orderSequence})</IonText>
              <CustomSpacer spacing="16px" />
              <ContentWrap>
                <IonText />
                <IonText className="bold">주문 {Math.abs(d.orderCount)?.toLocaleString() ?? 0} 개</IonText>
              </ContentWrap>
              <ContentWrap>
                <div>
                  <IonText className="title">단가 </IonText>
                  <IonText>{d.cost.toLocaleString() ?? 0} 원</IonText>
                </div>
                <IonText>체결 {Math.abs(d.count ?? 0)} 개</IonText>
              </ContentWrap>
              <ContentWrap>
                <div>
                  <IonText className="title">체결가 </IonText>
                  <IonText>{totalCost(d.count, d.tradeOrder?.cost) ?? 0} 원</IonText>
                </div>
                <IonText>잔여 {Math.floor(Math.abs(d.orderRemainCount ?? 0))} 개</IonText>
              </ContentWrap>
            </HistoryInfoContainer>
            <CustomSpacer spacing="16px" bottomLine={true} />
            <CustomSpacer spacing="16px" />
          </SectionContainer>
        </ProductInfoContainer>
      ))}
    </PagingContent>
  )
})

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
`

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  .section-title {
    font-size: 16px;
    font-weight: 700;
  }
  .order-sequence {
    margin-left: 4px;
    font-size: 11px;
    font-weight: 400;
    color: #888888;
  }
`

const HistoryInfoContainer = styled.div`
  cursor: pointer;
`

const ContentWrap = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 400;
  .bold {
    font-weight: bold;
  }
  div {
    display: flex;
    justify-content: space-between;
    .title {
      width: 43px;
    }
  }
`

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  .date {
    font-size: 12px;
    font-weight: 700;
  }
  .time {
    font-size: 11px;
    font-weight: 400;
    color: #888888;
  }
`
